export enum LoginAccessType {
  Bearer = 'Bearer',
}
